export const App = () => (
  <>
    <h1>Hello, I'm Jazzy!</h1>
  </>
);
